import React, { useState } from 'react';
import { Phone, Mail, MapPin, Heart, Clock } from 'lucide-react';
import { psychologistData } from '../mock';
import PrivacyPolicy from './PrivacyPolicy';
import TermsOfService from './TermsOfService';

const Footer = () => {
  const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(false);
  const [showTermsOfService, setShowTermsOfService] = useState(false);
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-8">
          {/* Quick Links */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold">Quick Links</h4>
            <div className="space-y-2">
              <button 
                onClick={() => scrollToSection('home')}
                className="block text-gray-300 hover:text-white transition-colors duration-200 text-sm"
              >
                Home
              </button>
              <button 
                onClick={() => scrollToSection('about')}
                className="block text-gray-300 hover:text-white transition-colors duration-200 text-sm"
              >
                About
              </button>
              <button 
                onClick={() => scrollToSection('services')}
                className="block text-gray-300 hover:text-white transition-colors duration-200 text-sm"
              >
                Services
              </button>
              <button 
                onClick={() => scrollToSection('contact')}
                className="block text-gray-300 hover:text-white transition-colors duration-200 text-sm"
              >
                Contact
              </button>
            </div>
          </div>

          {/* Contact Information */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold">Contact Info</h4>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <Phone className="text-green-400 mt-1 flex-shrink-0" size={16} />
                <div>
                  <p className="text-white text-sm font-medium">{psychologistData.contact.phone}</p>
                  <p className="text-gray-400 text-xs">Call/WhatsApp</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-3">
                <MapPin className="text-green-400 mt-1 flex-shrink-0" size={16} />
                <div>
                  <p className="text-white text-sm font-medium">Multiple Locations</p>
                  <p className="text-gray-400 text-xs">
                    {psychologistData.contact.locations.slice(0, 2).join(', ')}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="mt-12 pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-center md:text-left">
              <p className="text-gray-400 text-sm">
                © {new Date().getFullYear()} Manish Pacher. All rights reserved.
              </p>
              <p className="text-gray-500 text-xs mt-1">
                Clinical Psychologist & Family Therapist
              </p>
            </div>
            
            <div className="flex items-center space-x-6 text-xs text-gray-400">
              <button 
                onClick={() => setShowPrivacyPolicy(true)}
                className="hover:text-white transition-colors duration-200"
              >
                Privacy Policy
              </button>
              <span>•</span>
              <button 
                onClick={() => setShowTermsOfService(true)}
                className="hover:text-white transition-colors duration-200"
              >
                Terms of Service
              </button>
            </div>
          </div>
        </div>

        {/* Emergency Notice */}
        <div className="mt-8 p-4 bg-red-900/20 border border-red-800 rounded-lg">
          <p className="text-red-200 text-sm text-center">
            <strong>Emergency Notice:</strong> If you're experiencing a mental health emergency, 
            please call emergency services immediately or go to your nearest emergency room.
          </p>
        </div>
      </div>

      {/* Privacy Policy Modal */}
      {showPrivacyPolicy && (
        <PrivacyPolicy onClose={() => setShowPrivacyPolicy(false)} />
      )}

      {/* Terms of Service Modal */}
      {showTermsOfService && (
        <TermsOfService onClose={() => setShowTermsOfService(false)} />
      )}
    </footer>
  );
};

export default Footer;